module.exports = __webpack_public_path__ + "img/rd-fda-screenshot.32b389b2.png";